module.exports = __webpack_public_path__ + "media/images/home-banners/sunset-815270_1920-b45506c29eaf801419674095d5b694d3.jpg";